<template>
    <div class="scale-10-wrapper">
        <div class="scale-10 scale-names">
            <div class="scale-name1 border-right" :class='getTitleClass(0)'>{{ scales[0] }}</div>
            <div class="scale-name2 border-right" :class='getTitleClass(1)'>{{ scales[1] }}</div>
            <div class="scale-name3" :class='getTitleClass(2)'>{{ scales[2] }}</div>
        </div>
        <div class="scale-10">
            <div v-for="block in blockCount" :key="block" class="item-block" :class="getBlockClass(block)">
                <span v-if="block-1===valueNorm" class="item-value">{{rawValue}}</span>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { getColorZone } from '@/common/colorBlocks.js'

export default {
    props: {
        value: Number,
        rawValue: Number,
        normalizedTo: Number,
        scales: {
            type: Array,
            default() {
                return ["Низкая", "Средняя", "Высокая"]; 
            }
        }
    },
    components: {
    },
    data() {
        return {
            blockCount: 10,
        };
    },
    computed: {
        valueNorm() {
            let v = Math.floor((+this.value) / (+this.normalizedTo) * this.blockCount)
            return v
        },
        // valueNorm10() {
        //      return Math.floor((this.valueNorm-1)/10)+1
        // },
    },
    methods: {
        getBlockClass(indBlock) {
            const zone = getColorZone(this.valueNorm)
            return indBlock-1 <= this.valueNorm ? `item-block-${zone}` : `item-block-${zone}-light`
        },
        getTitleClass(indTitle) {
            const zone = getColorZone(this.valueNorm)
            if (indTitle === 0) return zone==='red' ? 'title-red' : ''
            if (indTitle === 1) return zone==='yellow' ? 'title-yellow' : ''
            if (indTitle === 2) return zone==='green' ? 'title-green' : ''
            return ''
        },
    },
};
</script>


<style scoped lang="scss">
@import "src/assets/styles/variables";

.scale-10-wrapper {
    width: fit-content;
}

.scale-10 {
    display: flex;
    width: 100%;
}

.scale-10 .item-block {
    background: #D3EDFF;
    width: 32px;
    height: 32px;
    border: 1px solid #39A9DC;
    border-radius: 5px;
    margin-right: 1px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}

.scale-10 .title-red {
    color: #E53E3E;
    font-weight: 600;
}
.scale-10 .title-green {
    color: #6FCF97;
    font-weight: 600;
}
.scale-10 .title-yellow {
    color: #F2C94C;
    font-weight: 600;
}

.scale-10 .item-block-red {
    background: #E53E3E;
    border-color: #E53E3E;
}
.scale-10 .item-block-red-light {
    background: #FCD0D0;
    border-color: #E53E3E;
}
.scale-10 .item-block-green {
    background: #6FCF97;
    border-color: #6FCF97;
}
.scale-10 .item-block-green-light {
    background: #E8F8EF;
    border-color: #6FCF97;
}
.scale-10 .item-block-yellow {
    background: #F2C94C;
    border-color: #F2C94C;
}
.scale-10 .item-block-yellow-light {
    background: #FFF8E5;
    border-color: #F2C94C;
}
.scale-10 .item-value {
    font-size: 16px;
    // font-size: 10px;
    font-weight: 400;
}

.scale-10 .scale-name1, .scale-10 .scale-name2, .scale-10 .scale-name3 {
    text-align: center;
    margin-top: 15px;
    padding-bottom: 5px;
}

.scale-10 .scale-name1 {
    flex: 0 0 30%;
}

.scale-10 .scale-name2 {
    flex: 0 0 30%;
}
.scale-10 .scale-name3 {
    flex: 0 0 40%;
}

.scale-10.scale-names {
    font-size: 11px;
    font-weight: 400;
}

.scale-10.scale-names .bold {
    font-weight: 600;
}

.border-right {
    border-right: 1px solid #DEE1EA;
}

@media screen and (max-width: 800px) {
    .scale-10 .item-block {
        width: 28px;
        height: 30px;
    }
    .scale-10 .item-value {
        font-size: 14px;
    }
    .scale-10.scale-names {
        font-size: 10px;
        margin-bottom: 4px;
    }
}

@media screen and (max-width: 600px) {
    .scale-10 .item-block {
        width: 20px;
        height: 18px;
    }
    .scale-10 .item-value {
        font-size: 11px;
    }
    .scale-10.scale-names {
        font-size: 7.5px;
        margin-bottom: 3px;
    }
}

</style>
